import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between gap-1 flex-wrap w-full" }
const _hoisted_2 = { class: "w-full flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center gap-x-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "block w-4 h-4",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z" })
], -1)
const _hoisted_5 = {
  key: 0,
  class: "capitalize"
}
const _hoisted_6 = { class: "w-full flex items-center justify-between mb-2" }
const _hoisted_7 = { class: "font-semibold text-base" }
const _hoisted_8 = { class: "text-base text-gray-500 my-3" }
const _hoisted_9 = { class: "grid grid-cols-3 gap-y-2" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "block w-4 h-4",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z" })
], -1)
const _hoisted_12 = { class: "h-6 px-2 rounded-full font-semibold test-sm leading-[100%] flex items-center justify-center bg-gray-50 border border-gray-300" }
const _hoisted_13 = { class: "w-full flex items-center justify-between mb-2" }
const _hoisted_14 = { class: "font-semibold text-base" }
const _hoisted_15 = { class: "flex flex-wrap gap-2" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_18 = { class: "rounded-md bg-indigo-50 px-3.5 py-2.5 text-sm font-semibold text-center text-[#155EEF] shadow-sm hover:bg-indigo-100 text-nowrap whitespace-nowrap" }
const _hoisted_19 = { class: "relative mt-2" }
const _hoisted_20 = { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }
const _hoisted_21 = ["onClick"]

import { filter, first } from "lodash";
import { computed, ref, watch, inject } from "vue";
import { useFilterStore } from "@/stores/filterStore";
import { MagnifyingGlassIcon } from "@heroicons/vue/24/outline";
import { ChevronUpDownIcon } from "@heroicons/vue/20/solid";
import SchoolLicenseComponent from "@/components/global/SchoolLicenseComponent.vue";
import i18n from "@/plugins/i18n";

import {
  Popover,
  PopoverPanel,
  PopoverButton,
  Combobox,
  ComboboxInput,
  ComboboxButton,
  ComboboxOptions,
  ComboboxOption,
} from "@headlessui/vue";

import { useLearnerStore } from "@/stores/learnerStore";
import { useDataStore } from "@/stores/dataStore";
import { useSchoolStore } from "@/stores/schoolStore";




export default /*#__PURE__*/_defineComponent({
  __name: 'SchoolFilterComponent',
  emits: ['update:searchQuery'],
  setup(__props, { emit }) {

const dataStore = useDataStore();
const filterStore = useFilterStore();
const schoolStore = useSchoolStore();
const learnerStore = useLearnerStore();

const bus = inject("bus");

const showStudentModal = (userId: string) => {
  bus.emit("show-student-modal", { userId: userId });
};

const activeStyles = ref({
  gradeLevel: "text-[#155EEF] ring-[#155EEF] bg-rl-primary-100",
});

const classesBySubjectAndGrade = computed(() => {
  const filteredBySubject = filter(
    filterStore.selectedSchool.classes,
    (classItem) => {
      return classItem.subject === filterStore.selectedFilters.subject;
    }
  );

  return filter(filteredBySubject, (classItem) => {
    return classItem.gradeLevel === filterStore.selectedFilters.gradeLevel;
  });
});

watch(
  () => filterStore.selectedFilters,
  () => {
    filterStore.filtersChanged = true;
  },
  { deep: true }
);

// Watch for changes to the selected school group
watch(
  () => filterStore.selectedFilters.schoolGroup,
  (newSchoolGroup) => {
    if (newSchoolGroup) {
      resetFiltersOnSchoolGroupChange();
    }
  }
);

watch(
  () => filterStore.selectedFilters.subject,
  (newSubject: string) => {
    if (newSubject) {
      filterStore.selectedFilters.classGroup = [];
    }
  }
);

watch(
  () => filterStore.selectedFilters.gradeLevel,
  (newGrade: number) => {
    if (newGrade) {
      filterStore.selectedFilters.classGroup = [];
    }
  }
);

// Method to reset filters when school group changes
const resetFiltersOnSchoolGroupChange = () => {
  const selectedSchoolGroup = filterStore.filterOptions?.schoolGroups.find(
    (sg) => sg._id === filterStore.selectedFilters.schoolGroup
  );

  if (selectedSchoolGroup && selectedSchoolGroup.schools.length > 0) {
    // Set the first school as default
    filterStore.selectedFilters.school = selectedSchoolGroup.schools[0]._id;

    // Set the first available grade level if grades exist
    const firstSchool = selectedSchoolGroup.schools[0];

    if (firstSchool.grades && firstSchool.grades.length > 0) {
      filterStore.selectedFilters.gradeLevel = firstSchool.grades[0]; // Select first grade level
    } else {
      filterStore.selectedFilters.gradeLevel = -1; // Reset if no grades are available
    }

    // Reset class groups
    filterStore.selectedFilters.classGroup = [];
  } else {
    // Reset everything if no schools are found
    filterStore.selectedFilters.school = "";
    filterStore.selectedFilters.gradeLevel = -1;
    filterStore.selectedFilters.classGroup = [];
  }

  filterStore.filtersChanged = true;
};

// Method to toggle class group selection
const toggleClassGroup = (classGroupId: string) => {
  const index = filterStore.selectedFilters.classGroup.indexOf(classGroupId);
  if (index > -1) {
    // Remove if already selected
    filterStore.selectedFilters.classGroup.splice(index, 1);
  } else {
    // Add if not selected
    filterStore.selectedFilters.classGroup.push(classGroupId);
  }
  filterStore.filtersChanged = true;
};

const applyFilters = async () => {
  if (filterStore.filtersChanged) {
    // Reset filtersChanged to false after applying filters
    filterStore.filtersChanged = false;

    await dataStore.fetchInitialData();
  }
};

// student search
const learnersList = computed(() => {
  const selectedGradeLevel = filterStore.selectedFilters.gradeLevel;
  const selectedClassGroups = filterStore.selectedFilters.classGroup;

  let filteredLearners = learnerStore.getSchoolLearners;

  if (selectedClassGroups && selectedClassGroups.length > 0) {
    // Filter learners by selected class groups
    filteredLearners = filteredLearners.filter(
      (learner) =>
        learner.classes &&
        learner.classes.some((classItem) =>
          selectedClassGroups.includes(classItem._id)
        )
    );
  } else if (selectedGradeLevel !== undefined && selectedGradeLevel !== -1) {
    // No class groups selected, filter learners by grade level
    filteredLearners = filteredLearners.filter(
      (learner) => learner.grade == selectedGradeLevel
    );
  } else {
    // Neither class groups nor grade level selected, return an empty array
    filteredLearners = [];
  }

  return filteredLearners.map((learner) => ({
    _id: learner._id,
    grade: learner.grade,
    classes: learner.classes,
    fullName: `${learner.firstName} ${learner.lastName}`,
    firstName: learner.firstName,
    lastName: learner.lastName,
  }));
});

const selectedLearner = ref(learnersList.value[0]);
const query = ref("");

const filteredLearners = computed(() =>
  query.value === ""
    ? learnersList.value
    : learnersList.value.filter((learner: any) => {
        // console.log(learner);
        return learner.firstName && learner.lastName && learner.fullName
          .toLowerCase()
          .includes(query.value.toLowerCase());
      })
);


watch(query, (newQuery) => {
  emit('update:searchQuery', newQuery);
});

// Method to clear the grade level filter
const clearGradeLevelFilter = () => {
  // filterStore.selectedFilters.gradeLevel = -1;
  // filterStore.selectedFilters.classGroup = [];
  // filterStore.selectClassGroups([]);
  // filterStore.filtersChanged = true;
  filterStore.clearGradeLevelFilter();
};

// Method to clear the class group filter
const clearClassGroupFilter = () => {
  // filterStore.selectedFilters.classGroup = [];
  // filterStore.filtersChanged = true;
  filterStore.clearClassGroupFilter();
};

function getStudentClassName(learner: any) {
  if (!learner || !learner.classes) return "";

  const classId = learner.classes.find((c: any) =>
    filterStore.selectedFilters.classGroup.includes(c._id)
  )?._id;

  if (!classId) return "";

  const classGroup = schoolStore.getSchoolStructure?.classGroups.find(
    (cg) => cg._id === classId
  );

  return classGroup ? classGroup.name : "";
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_FormKit, {
          type: "choose",
          name: "selectProduct",
          placeholder: 'Select Product',
          selectOptions: _unref(filterStore).subjectOptions,
          modelValue: _unref(filterStore).selectedFilters.subject,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filterStore).selectedFilters.subject) = $event))
        }, null, 8, ["selectOptions", "modelValue"]),
        _createElementVNode("div", null, [
          _createVNode(_unref(Popover), { class: "relative" }, {
            default: _withCtx(() => [
              _createVNode(_unref(PopoverButton), {
                type: "button",
                class: "w-fit relative inline-flex items-center gap-x-2 rounded-md bg-white px-3 py-2.5 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20"
              }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  (_unref(filterStore).selectedGrade > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("global.grade_naming_convention")), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(_unref(filterStore).selectedGrade > 0
                    ? _unref(filterStore).selectedGrade
                    : _unref(i18n).global.t("global.filters.choose_grade")), 1)
                ]),
                _: 1
              }),
              _createVNode(_Transition, {
                "enter-active-class": "transition duration-200 ease-out",
                "enter-from-class": "translate-y-1 opacity-0",
                "enter-to-class": "translate-y-0 opacity-100",
                "leave-active-class": "transition duration-150 ease-in",
                "leave-from-class": "translate-y-0 opacity-100",
                "leave-to-class": "translate-y-1 opacity-0"
              }),
              _createVNode(_unref(PopoverPanel), { class: "absolute z-20 mt-2 overflow-hidden rounded-lg bg-white px-4 py-4 text-left shadow-xl w-80 max-w-xs" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.$t("global.filters.filter")), 1),
                      _createElementVNode("button", {
                        onClick: clearGradeLevelFilter,
                        class: "font-semibold text-base text-gray-500"
                      }, _toDisplayString(_ctx.$t("global.filters.clear")), 1)
                    ]),
                    _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.$t("global.filters.grades")), 1),
                    _createElementVNode("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filterStore).selectedSchoolGrades, (grade, index) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: index,
                          onClick: ($event: any) => (
                    _unref(filterStore).selectGradeLevel(grade),
                    clearClassGroupFilter()
                  ),
                          class: _normalizeClass(["w-10 px-2 py-[0.125rem] rounded-full text-center text-sm font-semibold hover:bg-gray-50 ring-1 ring-inset", {
                    [activeStyles.value.gradeLevel]: _unref(filterStore).selectedGrade === grade,
                    'text-gray-900 ring-gray-300': _unref(filterStore).selectedGrade !== grade,
                    'bg-gray-200': _unref(filterStore).preselectedGrade === grade && _unref(filterStore).selectedGrade !== grade
                  }])
                        }, _toDisplayString(grade), 11, _hoisted_10))
                      }), 128))
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(_unref(Popover), { class: "relative" }, {
            default: _withCtx(() => [
              _createVNode(_unref(PopoverButton), { class: "w-fit relative inline-flex items-center gap-x-2 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20" }, {
                default: _withCtx(() => [
                  _hoisted_11,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("global.filters.filter_by_class")) + " ", 1),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(filterStore).selectedFilters.classGroup.length === 0 ? _unref(i18n).global.t("global.filters.all") : _unref(filterStore).selectedFilters.classGroup.length === 1 ? _unref(schoolStore).currentSchoolStructure?.classGroups.find(group => group._id === _unref(filterStore).selectedFilters.classGroup[0])?.name : `${_unref(filterStore).selectedFilters.classGroup.length}`), 1)
                ]),
                _: 1
              }),
              _createVNode(_Transition, {
                "enter-active-class": "transition duration-200 ease-out",
                "enter-from-class": "translate-y-1 opacity-0",
                "enter-to-class": "translate-y-0 opacity-100",
                "leave-active-class": "transition duration-150 ease-in",
                "leave-from-class": "translate-y-0 opacity-100",
                "leave-to-class": "translate-y-1 opacity-0"
              }),
              _createVNode(_unref(PopoverPanel), { class: "absolute z-20 mt-2 overflow-hidden rounded-lg bg-white px-4 py-4 text-left shadow-xl w-80 max-w-xs" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("h4", _hoisted_14, _toDisplayString(_ctx.$t("global.filters.filter")), 1),
                      _createElementVNode("button", {
                        onClick: clearClassGroupFilter,
                        class: "font-semibold text-base text-gray-500"
                      }, _toDisplayString(_ctx.$t("global.filters.clear")), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_15, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filterStore).classesBySubjectAndGrade, (classItem) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: classItem._id,
                            onClick: ($event: any) => (_unref(filterStore).toggleClassGroup(classItem._id)),
                            class: _normalizeClass(["w-auto px-2 py-[0.125rem] rounded-full text-center text-sm font-semibold hover:bg-gray-50 ring-1 ring-inset", {
                      [activeStyles.value.gradeLevel]: _unref(filterStore).selectedFilters.classGroup.includes(classItem._id),
                      'text-gray-900 ring-gray-300': !_unref(filterStore).selectedFilters.classGroup.includes(classItem._id),
                      'bg-gray-200': _unref(filterStore).preselectedClassGroups.includes(classItem._id) && !_unref(filterStore).selectedFilters.classGroup.includes(classItem._id)
                      }])
                          }, _toDisplayString(classItem.name), 11, _hoisted_16))
                        }), 128))
                      ])
                    ]),
                    _hoisted_17
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        (_unref(filterStore).filtersChanged)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(filterStore).applyFilters && _unref(filterStore).applyFilters(...args))),
              type: "button",
              class: "rounded-md bg-[#155EEF] px-2.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-[#155EEF] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#155EEF]"
            }, _toDisplayString(_ctx.$t("global.filters.apply_filters")), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(learnerStore).getCountOfLearnersByFilters) + " Students ", 1)
      ]),
      _createElementVNode("div", null, [
        _createVNode(SchoolLicenseComponent, { showAllLicenses: false })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_unref(Combobox), {
          as: "div",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (query.value = ''))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_unref(MagnifyingGlassIcon), {
                  class: "h-5 w-5 text-gray-400",
                  "aria-hidden": "true"
                })
              ]),
              _createVNode(_unref(ComboboxInput), {
                class: "w-full rounded-md border-0 bg-white py-1.5 pl-10 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-[#155EEF] sm:text-sm sm:leading-6",
                onChange: _cache[2] || (_cache[2] = ($event: any) => (query.value = $event.target.value)),
                placeholder: "Search"
              }),
              _createVNode(_unref(ComboboxButton), { class: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ChevronUpDownIcon), {
                    class: "h-5 w-5 text-gray-400",
                    "aria-hidden": "true"
                  })
                ]),
                _: 1
              }),
              (filteredLearners.value.length > 0)
                ? (_openBlock(), _createBlock(_unref(ComboboxOptions), {
                    key: 0,
                    class: "absolute z-20 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredLearners.value, (learner) => {
                        return (_openBlock(), _createBlock(_unref(ComboboxOption), {
                          key: learner._id,
                          value: learner,
                          as: "template"
                        }, {
                          default: _withCtx(({ active }) => [
                            _createElementVNode("li", {
                              class: _normalizeClass([
                    'relative cursor-default select-none py-2 pl-3 pr-9',
                    active ? 'bg-[#155EEF] text-white' : 'text-gray-900',
                  ]),
                              onClick: ($event: any) => (showStudentModal(learner._id))
                            }, _toDisplayString(learner.fullName), 11, _hoisted_21)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})